import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "stars"]

  connect() {
    this.updateStars(parseInt(this.inputTarget.value, 10) || 0)
  }

  set(event) {
    const selected = parseInt(event.target.dataset.ratingValue, 10)
    this.inputTarget.value = selected
    this.updateStars(selected)
  }

  updateStars(value) {
    const stars = this.starsTarget.querySelectorAll("i")
    stars.forEach((star, index) => {
      if (index < value) {
        star.classList.remove("fa-regular")
        star.classList.add("fa-solid")
      } else {
        star.classList.remove("fa-solid")
        star.classList.add("fa-regular")
      }
    })
  }
}
